import React, {useContext} from "react";
import {useLanguage} from "../../contexts/LanguageContext";
import StyleContext from "../../contexts/StyleContext";
import "./LanguageSelector.scss";

const LanguageSelector = () => {
  const {currentLanguage, changeLanguage} = useLanguage();
  const {isDark} = useContext(StyleContext);

  const languages = [
    {code: "en", name: "English", flag: "🇺🇸"},
    {code: "tr", name: "Türkçe", flag: "🇹🇷"},
    {code: "ar", name: "العربية", flag: "🇸🇦"}
  ];

  return (
    <div className={`language-selector ${isDark ? "dark" : ""}`}>
      <select
        value={currentLanguage}
        onChange={e => changeLanguage(e.target.value)}
        className="language-dropdown"
      >
        {languages.map(lang => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
